import isFunction from 'lodash-es/isFunction';
import * as React from 'react';
export function ListWithSelection(Component) {
    return class extends React.Component {
        // static defaultProps = { ...DefaultListProps };
        constructor(props) {
            super(props);
            this.onFocus = (index) => {
                this.focusOn(index);
            };
            this.onSelect = (item, index) => {
                const { onSelect } = this.props;
                if (!isFunction(onSelect)) {
                    return;
                }
                onSelect(item, index);
            };
            const { focusedIndex } = props;
            this.state = {
                focusedIndex,
                lastSelected: null
            };
        }
        componentWillReceiveProps(nextState) {
            const { items } = nextState;
            if (!items) {
                return;
            }
            const l = items.length - 1;
            let { focusedIndex: nextFocusedIndex } = nextState; // this.state;
            if (nextFocusedIndex > l) {
                // 0 or l - last item from new list
                nextFocusedIndex = 0;
            }
            this.setState({ focusedIndex: nextFocusedIndex });
        }
        focusOn(index) {
            let { focusedIndex } = this.state;
            if (focusedIndex === index) {
                return;
            }
            focusedIndex = index;
            this.setState({ focusedIndex });
        }
        focusOnPrev() {
            const { items, link = true } = this.props;
            const l = items.length - 1;
            let { focusedIndex } = this.state;
            if (focusedIndex === 0 && !link) {
                return;
            }
            if (focusedIndex === null) {
                focusedIndex = l;
            }
            else {
                focusedIndex = focusedIndex <= 0 ? l : focusedIndex - 1;
            }
            this.setState({ focusedIndex });
        }
        focusOnNext() {
            const { items, link = true } = this.props;
            const l = items.length - 1;
            let { focusedIndex } = this.state;
            if (focusedIndex === l && !link) {
                return;
            }
            if (focusedIndex === null) {
                focusedIndex = 0;
            }
            else {
                focusedIndex = focusedIndex >= l ? 0 : focusedIndex + 1;
            }
            this.setState({ focusedIndex });
        }
        select(index) {
            const { items } = this.props;
            const { focusedIndex } = this.state;
            index = index !== void 0 ? index : focusedIndex;
            const item = items[index];
            this.setState({
                lastSelected: item
            });
            this.focusOn(index);
            this.onSelect(item, index);
            return item;
        }
        render() {
            const { onFocus, onSelect } = this;
            const { items } = this.props;
            const { focusedIndex } = this.state;
            return (React.createElement(Component, Object.assign({}, this.props, { items: items, focusedIndex: focusedIndex, onFocus: onFocus, onSelect: onSelect })));
        }
    };
}
//# sourceMappingURL=ListWithSelection.js.map